const collectErrors = error => {
    const errors = [];

    if (!error) {
        return;
    } else if (error.response) {
        const {data} = error.response;

        if (data && data.error) {
            const {description, type} = data.error;
            let {detail} = data.error;

            if (type === 'VALIDATION') {
                Object.keys(detail).forEach(key => {
                    errors.push(detail[key]);
                });
            } else {
                errors.push(JSON.stringify(detail));
            }
        } else {
            errors.push(String(data));
        }

        return errors;
    }
};

const renderError = (error) => {
    if (!error) {
        return null;
    }

    if (error.response) {
        const {data} = error.response;
        if (data && data.error) {
            const {description, type} = data.error;
            let {detail} = data.error;
            if (type === 'VALIDATION') {
                detail = (
                    <ul>
                        {Object.keys(detail).map((key) => (
                            <li key={key}>{detail[key]}</li>
                        ))}
                    </ul>
                );
            } else {
                detail = JSON.stringify(detail);
            }
            return (
                <div className="error">
                    {detail && <br /> && detail}
                </div>
            );
        }

        return (
            <div className="error">
                {String(data)}
            </div>
        );
    }

    return (
        <div className="error">
            {String(error)}
        </div>
    );
};

export {
    collectErrors,
    renderError
};
